var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.582356 5.99094L10.5649 0.227103C10.9254 0.0193512 11.3691 0.0193512 11.7296 0.227103C12.0901 0.434854 12.312 0.820316 12.312 1.23582V5.96705L22.2529 0.227103C22.6138 0.0193512 23.0572 0.0193512 23.4176 0.227103C23.7781 0.434854 24 0.820316 24 1.23582V12.7631C24 13.1794 23.7781 13.5641 23.4176 13.7718C23.2374 13.8757 23.0365 13.9282 22.836 13.9282C22.6355 13.9282 22.4339 13.8757 22.2537 13.7718L12.312 8.03262V12.7631C12.312 13.1794 12.0901 13.5641 11.7296 13.7718C11.5494 13.8757 11.3482 13.9282 11.1473 13.9282C10.9464 13.9282 10.7452 13.8757 10.5653 13.7718L0.582356 8.00837C0.221867 7.80062 0 7.41516 0 6.99966C0 6.58415 0.221867 6.19869 0.582356 5.99094Z",
    fill: "#4B7FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.cabe76a27a602b59cd7f9271ef57668f.svg";
export { ForwardRef as ReactComponent };